// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"52":"9a2e1fcf","92":"b797a972","364":"e007af5c","468":"9a2e1fcf","522":"a42fcae6","622":"effd6770","671":"6a55bbcd","856":"1aa933a2"}[chunkId] + ".chunk.css";
};